import React, { useState, useEffect, useRef } from "react";
import { Link, useNavigate, useParams } from "react-router-dom";
import axios from "axios";
import loadings from "../../../components/Images/loading/loading.gif";
import Response_Processing from "../../../layout/Others/Response_Processing";
import AdminSaveHeader from "../../../components/CommonComponents/AdminSaveHeader";
import FormContainer from "../../../components/CommonComponents/FormContainer";
import LeftWrapper from "../../../components/CommonComponents/LeftWrapper";
import Wrapper from "../../../components/CommonComponents/Wrapper";
import RightWrapper from "../../../components/CommonComponents/RightWrapper";
import MessageHeading from "../../../components/CommonComponents/MessageHeading";

import FieldRenderer2 from "../../../CustomFields/FieldRenderer2";
import FieldRenderer from "../../../CustomFields/FieldRenderer";
import { toast } from "react-toastify";
import MessageLabel from "../../../components/CommonComponents/MessageLabel";
import AdminCustomInput from "../../../components/CommonComponents/AdminCustomInput";
import AdminSwitch from "../../../components/CommonComponents/AdminSwitch";
import AdminBackNavigation from "../../../components/CommonComponents/AdminBackNavigation";

const EditAdsPlan = (props) => {
  const { id } = useParams();
  const navigate = useNavigate();
  const [editUser, setEditUser] = useState({
    user_id: "",
    subscription_plan_name: "",
    subscription_plan_price: "",
    Ads_upload_count_limit: "",
    Ads_views_count_limit: "",
    subscription_plan_id: "",
    ios_plan_price: "",
    ios_product_id: "",
    billing_interval: "",
    billing_type: "",
    payment_type: "",
    PaymentGateway_id: "",
    plan_trail_days: "",
    plan_trail_status: "",
    status: "",
    selected_devices: ""
  });

  const [selectedDevices, setSelectedDevices] = useState({});
  const [customFieldValues, setCustomFieldValues] = useState({});
  useEffect(() => {
    if (Array.isArray(editUser?.selected_devices) && editUser?.selected_devices.length > 0) {
      const selected = {};
      editUser?.selected_devices.forEach((d) => {
        selected[d.id] = true; // store as boolean true for checked devices
      });
      setSelectedDevices(selected);
    }
  }, [editUser?.selected_devices]);


  const handleInputDevices = (id, checked) => {
    setSelectedDevices((prev) => ({
      ...prev,
      [id]: checked,
    }));
  };



  const [editname, setEditname] = useState({
    plan_name: "",
  });

  const [message, setMessage] = useState("");

  const [devices, setDevices] = useState([]);

  const access_token = localStorage.getItem("access_token");
  const user_id = localStorage.getItem("user_id");
  const headers = {
    "Content-Type": "application/json",
    Authorization: "Bearer " + access_token,
    Accept: "application/json",
    "Access-Control-Allow-Origin": "*",
  };

  const getUser = async () => {
    const reqData = await fetch(
      `${process.env.REACT_APP_Baseurl}/admin/advertisement/plans-edit/${id}`,
      { headers: headers }
    );
    const resData = await reqData.json();
    const res = resData.Ads_Subscription_Plans;

    setEditUser(res);
    setEditname(res);
    setDevices(resData?.devices);
  };

  useEffect(() => {
    getUser();
  }, [id]);


  const handleInput = (e) => {
    const { name, value } = e.target;
    setEditUser((prevEditUser) => ({
      ...prevEditUser,
      [name]: value,
    }));

    setValidationMessagesubscription_plan_name("");
    setIsValidationHiddensubscription_plan_name(true);
    setValidationMessagesubscription_plan_price("");
    setIsValidationHiddensubscription_plan_price(true);

    setEditUser({ ...editUser, [e.target.name]: e.target.value });

    if (e.target.checked === true) {
      setEditUser({ ...editUser, [e.target.name]: e.target.value });
      setEditUser({ ...editUser, [e.target.id]: 1 });
      setEditUser({
        ...editUser,
        [e.target.name]: e.target.value,
        [e.target.name]: 1,
      });
    } else {
      setEditUser({ ...editUser, [e.target.name]: e.target.value });
      setEditUser({ ...editUser, [e.target.id]: 0 });
      setEditUser({ ...editUser, [e.target.name]: e.target.value });
    }
  };
  const [validationMessagesubscription_plan_name, setValidationMessagesubscription_plan_name] =
    useState("");
  const [isValidationHiddensubscription_plan_name, setIsValidationHiddensubscription_plan_name] =
    useState(true);

  const [validationMessagesubscription_plan_price, setValidationMessagesubscription_plan_price] =
    useState("");
  const [isValidationHiddensubscription_plan_price, setIsValidationHiddensubscription_plan_price] =
    useState(true);
  const [validationMessagesubscription_plan_id, setValidationMessagesubscription_plan_id] =
    useState("");
  const [isValidationHiddensubscription_plan_id, setIsValidationHiddensubscription_plan_id] =
    useState(true);

  const [validationMessagepostdevices, setValidationMessagepostdevices] =
    useState("");
  const [isValidationHiddenpostdevices, setIsValidationHiddenpostdevices] =
    useState(true);

  const subscription_plan_nameInputRef = useRef(null);
  const subscription_plan_priceInputRef = useRef(null);
  const subscription_plan_idInputRef = useRef(null);
  const postdevicesInputRef = useRef(null);

  const [processing, setProcessing] = useState(false);
  const [showOverlay, setShowOverlay] = useState(false);

  const handleUpdate = async (e) => {
    let focusInputRef = null;

    if (editUser?.subscription_plan_name === "") {
      setValidationMessagesubscription_plan_name("Plan Name cannot be empty.");
      setIsValidationHiddensubscription_plan_name(false);
      focusInputRef = subscription_plan_nameInputRef;
    }
    if (editUser?.subscription_plan_price === "") {
      setValidationMessagesubscription_plan_price("Plan Amount cannot be empty.");
      setIsValidationHiddensubscription_plan_price(false);
      focusInputRef = subscription_plan_priceInputRef;
    }
    if (editUser?.subscription_plan_id === "") {
      setValidationMessagesubscription_plan_id("Plan ID cannot be empty.");
      setIsValidationHiddensubscription_plan_id(false);
      focusInputRef = subscription_plan_idInputRef;
    }
    const selectedIds = Object.keys(selectedDevices)?.filter((id) => selectedDevices[id]);

    if (selectedIds?.length === 0) {
      setValidationMessagepostdevices("Device cannot be empty.");
      setIsValidationHiddenpostdevices(false);
      focusInputRef = postdevicesInputRef;
      if (focusInputRef?.current) focusInputRef.current.focus();
      return;
    }

    setIsValidationHiddenpostdevices(true); // hide error if validation passes

    if (focusInputRef) {
      focusInputRef.current.focus();
      return;
    }

    e.preventDefault();

    const editInputvalue = {
      user_id: user_id,
      subscription_plan_name: editUser?.subscription_plan_name,
      subscription_plan_price: editUser?.subscription_plan_price,
      Ads_upload_count_limit: Number(editUser?.Ads_upload_count_limit),
      Ads_views_count_limit: Number(editUser?.Ads_views_count_limit),
      subscription_plan_id: editUser?.subscription_plan_id,
      ios_plan_price: editUser?.ios_plan_price,
      ios_product_id: editUser?.ios_product_id,
      billing_interval: editUser?.billing_interval,
      billing_type: editUser?.billing_type,
      payment_type: editUser?.payment_type,
      PaymentGateway_id: editUser?.PaymentGateway_id,
      plan_trail_days: editUser?.plan_trail_days,
      plan_trail_status: Number(editUser?.plan_trail_status),
      status: Number(editUser?.status),
      devices: selectedIds?.map((id) => Number(id)),

    };

    let firstApiStatus = false;
    let resultapi = null;
    let resultapifalse = null;
    let resjson = null;
    setProcessing(true);
    setShowOverlay(true);

    try {
      const res = await fetch(
        `${process.env.REACT_APP_Baseurl}/admin/advertisement/plans-update/${id}`,
        {
          method: "PATCH",
          headers: headers,
          body: JSON.stringify(editInputvalue),
        }
      );

      resjson = await res.json();

      if (resjson.status === true) {
        firstApiStatus = true;

        resultapi = resjson;
      } else if (resjson.status === false) {
        resultapifalse = resjson;
      }
    } catch (error) {
      console.error("Error:", error);
    }

    if (firstApiStatus) {
      try {
        const { saveCustomFieldsConditional } = await import('../../../CustomFields/conditionalCustomFieldsWrapper');
        const cfRes = await saveCustomFieldsConditional(
          process.env.REACT_APP_Baseurl,
          headers,
          'ads_plan',
          id,
          customFieldValues
        );
        if (!cfRes?.data?.status) throw new Error(cfRes?.data?.message || 'Failed to save additional fields');
      } catch (e) {
        toast.error(e?.response?.data?.message || e.message || 'Failed to save additional fields');
        setProcessing(false);
        setShowOverlay(false);
        return;
      }
      // try {
      //   const cfRes = await axios.post(`${process.env.REACT_APP_Baseurl}/admin/custom-field-values`, { entity_type: 'ads_plan', entity_id: id, values: {} }, { headers });
      //   if (!cfRes?.data?.status) throw new Error(cfRes?.data?.message || 'Failed to save additional fields');
      // } catch (e) {
      //   toast.error(e?.response?.data?.message || e.message || 'Failed to save additional fields');
      //   setProcessing(false);
      //   setShowOverlay(false);
      //   return;
      // }
      setValidationMessagesubscription_plan_name("");
      setValidationMessagesubscription_plan_price("");
      props.setApiresponsealert(resultapi);
      props.setShowalert(true);
      setTimeout(() => {
        window.location.reload();
      }, 3000);
    } else {
      if (resultapi === false) {
        var resultError = resultapi;
        props.setApiresponsealert(resultError);
        props.setShowalert(true);
        setIsValidationHiddensubscription_plan_name(false);
        setIsValidationHiddensubscription_plan_price(false);
        setProcessing(false);
        setShowOverlay(false);
      }
    }
  };

  return (
    <>
      <AdminBackNavigation path="/advertisement-subscription-plans" text="Back" />
      {showOverlay && <Response_Processing></Response_Processing>}
      <AdminSaveHeader heading={"Edit Ads Plan"} saveText={"Update"} saveMethod={handleUpdate} type="submit" />
      <FormContainer className="pb-5">
        <LeftWrapper>
          <Wrapper>
            <MessageHeading text={"Plans"} />

            <MessageLabel text={"Subscription Plan Name"} className="mandatorySimple" />
            <AdminCustomInput id="subscription-plan-name" name="subscription_plan_name" value={editUser?.subscription_plan_name} ref={subscription_plan_nameInputRef} onChange={handleInput} placeHolder={"Enter Plan Name"} error={validationMessagesubscription_plan_name} />

            <MessageLabel text={"Subscription Plan Id"} className="mandatorySimple" />
            <AdminCustomInput id="subscription-plan-id" name="subscription_plan_id" value={editUser?.subscription_plan_id} ref={subscription_plan_idInputRef} onChange={handleInput} placeHolder={"Enter Plan Id"} error={validationMessagesubscription_plan_id} />

            <MessageLabel text={"Subscription Plan Amount"} className="mandatorySimple" />
            <AdminCustomInput id="subscription-plan-price" name="subscription_plan_price" value={editUser?.subscription_plan_price} ref={subscription_plan_priceInputRef} onChange={handleInput} placeHolder={"Enter Plan Amount"} error={validationMessagesubscription_plan_price} />
          </Wrapper>


          <Wrapper>
            <MessageHeading text={" "} />

            <MessageLabel text={"Payment Type"} />
            <AdminCustomInput id="payment-type" name="payment_type" value={editUser?.payment_type} onChange={handleInput} placeHolder={"Enter Payment Type"} />

            <MessageLabel text={"Payment Gateway Id"} />
            <AdminCustomInput id="paymentGateway-id" name="PaymentGateway_id" value={editUser?.PaymentGateway_id} onChange={handleInput} placeHolder={"Enter Payment Gateway Id"} />
          </Wrapper>
          <Wrapper>
            <div className="card p-3 mt-3">
              <MessageHeading text="Additional Fields" />
              {/* Custom fields */}
              <FieldRenderer2
                pageIdentifier={"adsplans.edit"}
                entityType="ads_plan"
                entityId={id}
                text="Additional Fields"
              />
              <FieldRenderer
                pageIdentifier={"adsplans.edit"}
                entityType="ads_plan"
                entityId={id}
                onChange={setCustomFieldValues}
              />
            </div>
          </Wrapper>
        </LeftWrapper>

        <RightWrapper>
          <Wrapper>
            <MessageHeading text={"Intervals"} />
            <MessageLabel text={"Billing Interval"} />
            <AdminCustomInput id="billing-interval" name="billing_interval" value={editUser?.billing_interval} onChange={handleInput} placeHolder={"Enter Billing Interval"} />
          </Wrapper>

          <Wrapper>
            <MessageHeading text={" "} />

            <MessageLabel text={"Ads Upload Count Limit"} />
            <AdminCustomInput type={"number"} id="Ads-upload-count-limit" name="Ads_upload_count_limit" value={editUser?.Ads_upload_count_limit} onChange={handleInput} placeHolder={"Enter Ads Upload Limit"} />

            <MessageLabel text={"Ads Views Count Limit"} />
            <AdminCustomInput type={"number"} id="Ads-views-count-limit" name="Ads_views_count_limit" value={editUser?.Ads_views_count_limit} onChange={handleInput} placeHolder={"Enter Ads Views Limit"} />
          </Wrapper>


          <Wrapper>
            <MessageHeading text={"Status"} />
            <div className="d-flex justify-content-between mb-2 ">
              <div className="col-6 col-md-6 pe-2">
                <span>{"Status"}</span>
              </div>
              <div className="col-6 col-md-6 ps-2 text-end">
                <AdminSwitch id="status" name={'status'} checked={editUser?.status === 1 || editUser?.status === "1"} onChange={handleInput} />
              </div>
            </div>
          </Wrapper>
        </RightWrapper>
      </FormContainer>

    </>
  );
};

export default EditAdsPlan;
